import React, { useEffect, useRef, useState } from "react";
import "./AtlasChatComponent.css";
import { GetOktaAuthData, GetUserId } from "../../Utils/Utils";
import plusnewchat from "../../Assets/plusnewchat.svg";
import DisclaimerModal from "./DisclaimerModal";
import mbicon from "../../Assets/mb-sidebar-atlas.svg";
import atlaschatlogo from "../../Assets/Atlas-Logo.svg";
import MbSliderAtlas from "./MbSliderAtlas";
import ChatInterface from "./chat/ChatInterface";

const AtlasChatComponent = () => {
  const user = GetOktaAuthData();
  const userId = GetUserId();
  const userProfileData = user?.user?.profile;

  const [inputDisabled, setInputDisabled] = useState(false);
  const [isConnected, setIsConnected] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isTabPortrait, setIsTabPortrait] = useState(false);
  const [isTabletLandscape, setIsTabletLandscape] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const mq = window.matchMedia(
      "(min-width: 768px) and (max-width: 1024px) and (orientation: portrait)",
    );
    const handler = (e) => setIsTabPortrait(e.matches);
    handler(mq);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  useEffect(() => {
    const mq = window.matchMedia(
      "(min-width: 768px) and (max-width: 1024px) and (orientation: landscape)",
    );
    const handler = (e) => setIsTabletLandscape(e.matches);
    setIsTabletLandscape(mq.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  const [showDisclaimer, setShowDisclaimer] = useState(false);
  const [openSlide, setOpenSlide] = useState(false);
  const [hasMessages, setHasMessages] = useState(false);
  const chatRef = useRef(null);

  const onNewChat = () => setHasMessages(false);
  const handleNewChat = () => chatRef.current?.newChat();

  return (
    <div className="atlas-chat-main-start">
      {isMobile ? (
        <div className="atlas-chat-heading-video">
          <p className="Heading-inner-head">
            <img src={mbicon} alt="" onClick={() => setOpenSlide(true)} />
          </p>
          <p className="hi-dash-name-atlaschat-mb">
            <img src={atlaschatlogo} alt="" />
          </p>
          <p></p>
        </div>
      ) : (
        <div className="atlas-chat-heading-video">
          {/* <p
            className="Heading-inner-head"
            style={inputDisabled ? { pointerEvents: "none", opacity: 0.5 } : {}}
            onClick={handleNewChat}
          > */}
          <p
            className={`Heading-inner-head ${
              inputDisabled ? "heading-disabled" : ""
            }`}
            onClick={!inputDisabled ? handleNewChat : undefined}
          >
            <img src={plusnewchat} alt="" />
            New Chat
          </p>
          <p
            className="name-atlaschat-updates"
            // style={{
            //   display: "inline-flex",
            //   alignItems: "center",
            //   gap: "6px",
            //   padding: "6px 14px",
            //   border: "1px solid #E5E7EB",
            //   borderRadius: "20px",
            //   background: "#FFFFFF",
            //   fontSize: "14px",
            //   fontWeight: "500",
            //   color: "#111827",
            //   boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            //   margin: 0,
            //   width: "fit-content",
            // }}
          >
            <span
              className={
                isConnected
                  ? "status-indicator-atlas"
                  : "status-indicator-atlas-error"
              }
              // style={{
              //   width: "8px",
              //   height: "8px",
              //   borderRadius: "50%",
              //   background: isConnected ? "#22C55E" : "#ef4444",
              //   display: "inline-block",
              //   boxShadow: isConnected
              //     ? "0 0 6px rgba(34,197,94,0.6)"
              //     : "0 0 6px rgba(239,68,68,0.6)",
              // }}
            ></span>
            Atlas Chat
          </p>
          <p></p>
        </div>
      )}

      <MbSliderAtlas
        openSlide={openSlide}
        setOpenSlide={setOpenSlide}
        inputDisabled={inputDisabled}
        plusnewchat={plusnewchat}
        checked={false}
        handleNewChatNormal={handleNewChat}
        handleNewChatDeep={handleNewChat}
        setIsFeedbackOpen={() => {}}
      />

      <ChatInterface
        ref={chatRef}
        userId={userId}
        userProfileData={userProfileData}
        isMobile={isMobile}
        isTabPortrait={isTabPortrait}
        isTabletLandscape={isTabletLandscape}
        inputDisabled={inputDisabled}
        setInputDisabled={setInputDisabled}
        setConnectionStatus={setIsConnected}
        handleOpenDisclaimer={() => setShowDisclaimer(true)}
        onNewChat={onNewChat}
      />

      <DisclaimerModal
        open={showDisclaimer}
        onClose={() => setShowDisclaimer(false)}
        isMobile={isMobile}
        isTabPortrait={isTabPortrait}
      />
    </div>
  );
};

export default AtlasChatComponent;
